import React, { useEffect, useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import CustomizedButton from "@components/ButtonConfirm/ButtonConfirm";
import {
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
} from "store/supplier/supplier.api";
import FileUploader from "@components/customInputFile/CustomInputFile";
import { getFileName } from "helpers/getFileNameFromPath";

const CreateSupplierComponent = ({ onClose, supplier, isUpdate, onSupplierCreated }) => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  const createdBy = currentUser?._id;
  const roleId = currentUser?.roleId?._id;

  const [createSupplier, { isLoading }] = useCreateSupplierMutation();
  const [updateSupplier, { isLoading: isLoadingUpdate }] =
    useUpdateSupplierMutation();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      name: supplier?.name || "",
      email: supplier?.email || "",
      telephone: supplier?.telephone || "",
      address: supplier?.address || "",
    },
  });

  const [kbisFile, setKbisFile] = useState(null);
  const [fiscalDocFile, setFiscalDocFile] = useState(null);
  const [urssafDocFile, setUrssafDocFile] = useState(null);

  useEffect(() => {
    if (supplier) {
      reset({
        name: supplier.name,
        email: supplier.email,
        telephone: supplier.telephone,
        address: supplier.address,
      });
    }
  }, [supplier, reset]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("telephone", data.telephone);
    formData.append("address", data.address);
    formData.append("companyId", companyId);
    formData.append("createdBy", createdBy);
    formData.append("roleId", roleId);

    if (kbisFile) formData.append("kbis", kbisFile);
    if (fiscalDocFile) formData.append("fiscalDoc", fiscalDocFile);
    if (urssafDocFile) formData.append("urssafDoc", urssafDocFile);

    try {
      if (isUpdate) {
        const updatedSupplier = await updateSupplier({ id: supplier._id, data: formData }).unwrap();
        toast.success(t("supplier.update_success"));
        if (onSupplierCreated) {
          onSupplierCreated(updatedSupplier);
        }
      } else {
        const createdSupplier = await createSupplier(formData).unwrap();
        console.log("=== SUPPLIER CREATION SUCCESS ===");
        console.log("Created supplier response:", createdSupplier);
        console.log("Supplier ID:", createdSupplier._id);
        console.log("Supplier name:", createdSupplier.name);
        console.log("Supplier email:", createdSupplier.email);
        
        toast.success(t("supplier.create_success"));
        if (onSupplierCreated) {
          console.log("Calling onSupplierCreated callback with:", createdSupplier);
          onSupplierCreated(createdSupplier);
        }
      }
      onClose();
      reset();
    } catch (error) {
      console.error('Supplier creation error:', error);
      toast.error(t("supplier.create_error"));
    }
  };

  return (
    <div className="supplier-form-container">
      <div className="row-container">
        <div className="input-container">
          <div className="input-title">{t("supplier.form.name")}</div>
          <input
            {...register("name", {
              required: t("supplier.form.name_required"),
            })}
            className="input-content"
            placeholder={t("supplier.form.name_placeholder")}
          />
        </div>
        <div className="input-container">
          <div className="input-title">{t("supplier.form.email")}</div>
          <input
            {...register("email", { required: "supplier.form.email_required" })}
            className="input-content"
            placeholder="Email"
            type="email"
          />
        </div>
      </div>

      <div className="row-container">
        <div className="input-container">
          <div className="input-title">{t("supplier.form.telephone")}</div>
          <input
            {...register("telephone", { required: "Téléphone requis" })}
            className="input-content"
            placeholder={t("supplier.form.telephone_placeholder")}
          />
        </div>
        <div className="input-container">
          <div className="input-title">{t("supplier.form.address")}</div>
          <input
            {...register("address", { required: "Adresse requise" })}
            className="input-content"
            placeholder={t("supplier.form.address_placeholder")}
          />
        </div>
      </div>

      <div className="row-container">
        <FileUploader
          label={t("supplier.form.label_urssaf")}
          file={urssafDocFile}
          setFile={setUrssafDocFile}
          id="urssafDoc"
          isUpdate={isUpdate}
          existingFile={supplier?.idDocumenturssafDoc}
          path={supplier?.idDocumenturssafDoc}
        />

        <FileUploader
          label={t("supplier.form.label_kbis")}
          file={kbisFile}
          setFile={setKbisFile}
          id="kbis"
          isUpdate={isUpdate}
          existingFile={supplier?.idDocumentkbis}
          path={supplier?.idDocumentkbis}
        />

        <FileUploader
          label={t("supplier.form.label_fiscal")}
          file={fiscalDocFile}
          setFile={setFiscalDocFile}
          id="fiscalDoc"
          isUpdate={isUpdate}
          existingFile={supplier?.idDocumentfiscalDoc}
          path={supplier?.idDocumentfiscalDoc}
        />
      </div>

      <CustomizedButton
        stylee={{ width: "60% !important", margin: "1.5rem  auto" }}
        creatingText={
          isUpdate ? t("supplier.update") : t("supplier.form.creating")
        }
        finalizeText={
          isUpdate ? t("supplier.update") : t("supplier.form.submit")
        }
        handleCreate={handleSubmit(onSubmit)}
        isCreating={isLoading || isLoadingUpdate}
        bgColor={"#17253d"}
      />
    </div>
  );
};

export default CreateSupplierComponent;
